import { render, staticRenderFns } from "./ItemHabit.vue?vue&type=template&id=75357089&"
import script from "./ItemHabit.vue?vue&type=script&lang=js&"
export * from "./ItemHabit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports